// Operational reports contain route categories and event types only. Never send
// exception text, console output, DOM text, form data, query strings or credentials.
const seen = new Map();
const known = new Set("api deploy pilot pilot-errors applications config auth register login logout session forgot-password reset-password send-verification-email verify-email billing subscription checkout portal cores select cancel projects keys rotate revoke usage infrastructure status public repository bind verify stripe connect callback mcp limelite account dashboard setup docs legal csrf health".split(" "));
export function diagnosticPath(value = "") {
  return "/" + String(value).split(/[?#]/)[0].split("/").filter(Boolean).slice(0, 8).map((part) => known.has(part) ? part : ":id").join("/");
}
export function isPilotPage() {
  return typeof window !== "undefined" && /^\/limelite(?:\/|$)/.test(window.location.pathname);
}
export async function reportPilotIssue(kind, endpoint = "") {
  const page = diagnosticPath(window.location.pathname);
  const safeEndpoint = diagnosticPath(endpoint);
  const key = `${kind}:${page}:${safeEndpoint}`;
  if (kind !== "support_request" && Date.now() - (seen.get(key) || 0) < 60000) return null;
  if (seen.size >= 100) seen.delete(seen.keys().next().value);
  seen.set(key, Date.now());
  const clientReference = window.crypto?.randomUUID ? `LP-${window.crypto.randomUUID()}` : undefined;
  // Import lazily to avoid an initialisation cycle with the Axios interceptor.
  const { csrfFetch } = await import("./installCsrfAxios");
  const response = await csrfFetch("/api/deploy/pilot-errors", { method: "POST", credentials: "include", keepalive: true,
    headers: { "Content-Type": "application/json" }, body: JSON.stringify({ kind, page, endpoint: safeEndpoint, clientReference }) });
  if (!response.ok) throw new Error("Support report unavailable");
  const body = await response.json();
  if (!body.success) throw new Error("Support report unavailable");
  return body.reference;
}
export function reportPilotNetworkFailure(error) {
  if (!isPilotPage() || error?.response || error?.code === "ERR_CANCELED") return;
  const endpoint = String(error?.config?.url || "");
  if (!endpoint.startsWith("/api/deploy/") || endpoint.startsWith("/api/deploy/pilot-errors")) return;
  void reportPilotIssue("network_failure", endpoint).catch(() => {});
}
export function installPilotDiagnostics() {
  window.addEventListener("error", () => { if (isPilotPage()) void reportPilotIssue("frontend_exception").catch(() => {}); });
  window.addEventListener("unhandledrejection", () => { if (isPilotPage()) void reportPilotIssue("promise_rejection").catch(() => {}); });
}
